// Don't reorder!
export enum WweFeature {
	BUY_FUNDS,
	COMPARE,
	TRANSIENT_ANALYSIS,
	WORST_TAX_OFFENDERS
}
